export let events;
(function (events) {
  events["growthPaymentsPageView"] = "growthPaymentsPageView";
  events["hubSpotApplicationFormInteraction"] = "hubSpotApplicationFormInteraction";
  events["paymentSettingsInteraction"] = "paymentSettingsInteraction";
  events["hubSpotApplicationSubmissionIneligibleMerchant"] = "hubSpotApplicationSubmissionIneligibleMerchant";
})(events || (events = {}));